import { noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import StepContent from './StepContent'

type TStepItemWrapper = {
  color?: string
}

export type TStep = {
  position?: number
}

export type TStepItem = {
  index?: number
  onClick?: (val?: number) => void
  step?: TStep
  color?: string
  current?: number
  onChange?: (val?: number) => void
  disableSkip?: boolean
  validateStep?: (val?: number) => void
  textColor?: string
  disabledClick?: boolean
  disableNext?: boolean
}

const StepItemWrapper = styled.div<TStepItemWrapper>`
  height: auto;
  width: 200px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #99a2a8;
  font-weight: bold;

  &.active,
  &.done {
    color: ${({ color }) => color || 'black'};
  }
  &.active .stepbar__item-tail:after,
  &.done .stepbar__item-tail:after {
    background-color: ${({ color }) => color || 'black'};
  }

  &.active .stepbar__item-icon-wrapper,
  &.done .stepbar__item-icon-wrapper {
    color: white;
    background-color: ${({ color }) => color || 'black'};
    border: 1px solid ${({ color }) => color || 'eaf0f4'};
    cursor: pointer;
  }

  .stepbar__container.vertical & {
    margin-bottom: 20px;
    width: auto;
    height: auto;
    justify-content: flex-start;
    &:last-child .stepbar__item-tail:after {
      display: none;
    }
    &.active .stepbar__item-tail:after {
      background-color: #eaf0f4;
    }
  }

  &:not(.done):not(.active).disabled {
    cursor: not-allowed;
  }
`

const StepItemTail = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  top: 15px;
  padding: 0px;
  z-index:2;
  &:after {
    content: "";
    display: inline-block;
    background: #eaf0f4;
    height: 5px;
    border-radius: 1px;
    width: 100%;
    transition: background 0.5s;
  }
  height: 100%;
    display: flex;
    justify-content: center;
  .stepbar__container.vertical & {
    position: absolute;
    top: 0;
    height: 70px;
    width: 5px;
    padding: 30px 0 4px 0;
    left: 18px;
    padding: 0px 0 4px 0;
    &:after {
      height: 100%;
      width: 20px;

    }
  }
}
`

const StepItem = (props: TStepItem): React.ReactElement => {
  const {
    color,
    current = 0,
    index = 0,
    onClick,
    step,
    disabledClick,
    disableSkip,
    disableNext,
    textColor,
  } = props

  const isPreventClick = (): boolean => {
    if (disabledClick) {
      return true
    }
    return Boolean(
      (disableSkip && current + 1 < index) || (disableNext && current < index),
    )
  }
  return (
    <StepItemWrapper
      color={color}
      className={`${current > index ? 'done' : ''} ${
        current === index ? 'active' : ''
      }
       ${disableSkip && current + 1 < index ? 'disabled' : ''}
       ${disableNext && current < index ? 'disabled' : ''}
      `}
      onClick={() => (isPreventClick() || !onClick ? noop : onClick(index))}
    >
      <StepContent color={color} textColor={textColor} {...step} />
      <StepItemTail className="stepbar__item-tail" />
    </StepItemWrapper>
  )
}

export default StepItem
